import React from 'react'
import Reflux from 'reflux'
import axios from 'axios'
import { Card, CardHeader, CardBody, CardFooter, Button, Container, Row, Col } from 'reactstrap'
import FontAwesome from 'react-fontawesome'

import CurrentRecipeStore from '~/stores/currentRecipe.js'

import CoreSimpleTextbox from 'core/simpleTextbox.jsx'
import CoreSimpleTextArea from 'core/simpleTextArea.jsx'
import apiUtils from '~/helper/api.js'


export default class RecipeDetails extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleChangeField = (event) => {
		this.setState({ [event.target.name]: event.target.value })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	saveGeneralInfo = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.put(
			`${apiUtils.getApiURL()}/recipes`,
			{
				recipeID: this.state.recipeID,
				categoryID: this.state.categoryID,
				recipe: this.state.recipe,
				description: this.state.description,
				link: this.state.link,
				fromWho: this.state.fromWho,
				preheat_temp: this.state.preheat_temp,
				yield: this.state.yield,
				servings: this.state.servings,
				timePrep: this.state.timePrep,
				timeCook: this.state.timeCook,
				timeReady: this.state.timeReady
			}
		)
			.then(
				() => {
					alert('Saved! (I will make this look nicer later)')
				}
			)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const isLoaded = this.state.recipeID > 0

		return (isLoaded)
			? (
				<Card>
					<CardHeader>
						General Info
					</CardHeader>
					<CardBody>
						<p>
							<FontAwesome name="info-circle" />
							{' '}
							To save changes in this section, click the &quot;Save General Info&quot; button below
						</p>

						<br />

						<Container>
							<Row>
								<Col xs={2}>
									Recipe Name:
								</Col>
								<Col xs={10}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={64}
										name="recipe"
										value={this.state.recipe || ''}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									Description:
								</Col>
								<Col xs={10}>
									<CoreSimpleTextArea
										onChange={this.handleChangeField}
										type="textarea"
										name="description"
										value={this.state.description}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									Link:
								</Col>
								<Col xs={10}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={512}
										name="link"
										value={this.state.link || ''}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									From Who:
								</Col>
								<Col xs={10}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={32}
										name="fromWho"
										value={this.state.fromWho || ''}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									Preheat Temp:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={3}
										name="preheat_temp"
										value={this.state.preheat_temp}
									/>
								</Col>
								<Col xs={2} />
								<Col xs={2}>
									Time Prep:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={64}
										name="timePrep"
										value={this.state.timePrep || ''}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									Yield:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={16}
										name="yield"
										value={this.state.yield || ''}
									/>
								</Col>
								<Col xs={2} />
								<Col xs={2}>
									Time Cook:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={64}
										name="timeCook"
										value={this.state.timeCook || ''}
									/>
								</Col>
							</Row>

							<Row><Col xs={12}>&nbsp;</Col></Row>

							<Row>
								<Col xs={2}>
									Servings:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={64}
										name="servings"
										value={this.state.servings || ''}
									/>
								</Col>
								<Col xs={2} />
								<Col xs={2}>
									Time Ready:
								</Col>
								<Col xs={2}>
									<CoreSimpleTextbox
										onChange={this.handleChangeField}
										maxLength={64}
										name="timeReady"
										value={this.state.timeReady || ''}
									/>
								</Col>
							</Row>
						</Container>
					</CardBody>
					<CardFooter
						className="text-center"
					>
						<Button
							color="primary"
							onClick={this.saveGeneralInfo}
						>
							Save General Info
						</Button>
						{' '}
						<Button
							color="secondary"
						>
							Cancel
						</Button>
					</CardFooter>
				</Card>
			)
			: <div>loading...</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/general.jsx